import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-addmember',
  templateUrl: './addmember.component.html',
  styleUrls: ['./addmember.component.scss']
})
export class AddmemberComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}

